import { render } from "./homeNotice.vue?vue&type=template&id=b00d3618&scoped=true"
import script from "./homeNotice.vue?vue&type=script&lang=js"
export * from "./homeNotice.vue?vue&type=script&lang=js"

import "./homeNotice.vue?vue&type=style&index=0&id=b00d3618&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00d3618"]])

export default __exports__